<template id="footer-view">
  <footer class="container-fluid">
    <div class="container">
      <div class="row">
        <img src="/static/logo.svg" alt="MONS" height="50" class="col-md-6 offset-md-3">
      </div>

      <div class="row">
        <ul>
          <li>
            <router-link :to="{name: 'home'}">{{ $t('navigation.home') }}</router-link>
          </li>

          <li>
            <router-link :to="{name: 'about'}">{{ $t('navigation.about') }}</router-link>
          </li>

          <li>
            <router-link :to="{name: 'key_articles'}">{{ $t('navigation.key_articles') }}</router-link>
          </li>

          <li>
            <router-link :to="{name: 'blog'}">{{ $t('navigation.blog') }}</router-link>
          </li>

          <li>
            <router-link :to="{name: 'video'}">{{ $t('navigation.video') }}</router-link>
          </li>

          <li>
            <router-link :to="{name: 'infographics'}">{{ $t('navigation.infographics') }}</router-link>
          </li>

          <li>
            <router-link :to="{name: 'contact'}">{{ $t('navigation.contact') }}</router-link>
          </li>
        </ul>
      </div>

      <div class="row">
        <div class="social-media">
          <a href="https://www.facebook.com/monitoring.mons/" target="_blank"><i class="fa fa-facebook-official" aria-hidden="true"></i></a>
          <a href="https://twitter.com/monitoring_MONS" target="_blank"><i class="fa fa-twitter-square" aria-hidden="true"></i></a>
        </div>
      </div>

      <center>
        <p>Copyright {{ year }} MONS</p>
      </center>

    </div>
  </footer>
</template>

<script>
  export default {
    name: 'FooterView',
    computed: {
      year: function () {
        return new Date().getFullYear()
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import "~styles/_vars.scss";

  footer {
    padding: 2rem;
    background: $primary-color;
    background: linear-gradient(225deg, #A92A49, #6C182A);
    color: white;
  }

  ul {
    text-align: center;
    list-style: none;
    margin: 2rem auto 1rem auto;

    li {
      display: inline;
      color: white;
      padding: 1rem;

      a {
        color: white;
        text-decoration: none;
        outline: none;
        transition: all 0.2s;
        font-weight: 100;
        &:hover {
          color: darken(white, 15%);
        }
      }
    }
  }

  p {
    margin: 0;
    padding: 0;
    text-align: center;
    color: lighten($primary-color, 30%);
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.05rem;
  }

  .social-media {
    margin: 0 auto 1rem auto;
    a i {
      transition: all 0.15s;
      font-size: 2rem;
      color: white;
      padding: 0.5rem;
      &:hover {
        color: lighten($primary-color, 35%);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Footer.vue?a58f2102